import type { FC } from "react";
import { useMemo } from "react";

import type { ChipGroupItem } from "app/pages/sales-intelligence/common-components/filters-panel/components/ChipsGroup/ChipsGroup";
import ChipsGroup from "app/pages/sales-intelligence/common-components/filters-panel/components/ChipsGroup/ChipsGroup";
import { operatorOptionMap } from "app/pages/sales-intelligence/types/commonMaps";

import type { TechnologiesContentEnum, TechnologiesFilterDto } from "../../types/technologies";
import { getTechnologyChipsData, manageTechnologyChipsItemByType } from "../../utils/technologies";

interface ITechnologyChipsGroupProps {
    item: TechnologiesFilterDto;
    onChangeTechnology: (item: TechnologiesFilterDto) => void;
}

const TechnologyChipsGroup: FC<ITechnologyChipsGroupProps> = ({ item, onChangeTechnology }) => {
    const handleOnChipDelete = (chipItem: ChipGroupItem) => {
        const technologyItem = manageTechnologyChipsItemByType(chipItem, item);
        onChangeTechnology(technologyItem);
    };

    const chipsData = useMemo(() => {
        return getTechnologyChipsData(item);
    }, [item]);

    return (
        <ChipsGroup<TechnologiesContentEnum>
            chipItems={chipsData}
            divider={operatorOptionMap.or}
            onDelete={handleOnChipDelete}
        />
    );
};

export default TechnologyChipsGroup;
